export const VACCINATION_COUNT = "/api/vaccination-kpi"
export const SUPERSET_TOKEN = "/api/dashboard/get_token/"
